import { z } from 'zod';
export const FIELD_MODES = ['off', 'optional', 'required'];
export const formFieldsSchema = z.object({
    email: z.enum(FIELD_MODES).default('optional'),
    area: z.enum(['off', 'optional']).default('optional'),
    message: z.enum(['off', 'optional']).default('optional'),
});
export const upsertLeadFormSchema = z.object({
    slug: z.string().trim().toLowerCase().regex(/^[a-z0-9]([a-z0-9-]{0,38}[a-z0-9])?$/, 'Use letras minúsculas, números e hífen (ex.: avaliacao)'),
    name: z.string().trim().min(2, 'Dê um nome ao formulário').max(80),
    title: z.string().trim().min(2).max(120),
    subtitle: z.string().trim().max(280).nullable().default(null),
    fields: formFieldsSchema.default({ email: 'optional', area: 'optional', message: 'optional' }),
    successMessage: z.string().trim().min(2).max(400),
    welcomeWhatsapp: z.string().trim().max(1000).nullable().default(null),
    active: z.boolean().default(true),
});
export const leadFormSchema = upsertLeadFormSchema.extend({
    id: z.uuid(), url: z.string(), submissions: z.number().int(), lastSubmissionAt: z.string().nullable(), createdAt: z.string(),
});
/** O que o formulário público precisa (sem nada interno). */
export const publicFormSchema = z.object({
    title: z.string(), subtitle: z.string().nullable(), fields: formFieldsSchema, clinicName: z.string(), privacyUrl: z.string(),
});
export const TRACKING_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
export const submitFormSchema = z.object({
    name: z.string().trim().min(2, 'Diga seu nome').max(120),
    phone: z.string().trim().min(8, 'Informe o celular com DDD').max(20),
    email: z.email('E-mail inválido').max(200).optional().or(z.literal('').transform(() => undefined)),
    area: z.enum(['scalp', 'eyebrow', 'beard', 'other']).optional(),
    message: z.string().trim().max(1000).optional(),
    consent: z.literal(true, { error: 'Aceite para enviar' }),
    /** campo-armadilha: gente não preenche (robôs sim) */
    website: z.string().max(0).optional(),
    /** ms entre abrir e enviar (robôs enviam em milissegundos) */
    elapsedMs: z.number().int().min(0).max(86_400_000),
    tracking: z.object({
        ...Object.fromEntries(TRACKING_KEYS.map((k) => [k, z.string().trim().max(300).optional()])),
        page: z.string().trim().max(500).optional(),
        referrer: z.string().trim().max(500).optional(),
    }).partial().default({}),
});
//# sourceMappingURL=forms.js.map